'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dom = exports.getSizeClassName = exports.noop = exports.trim = exports.autoFillUrl = exports.loadJs = exports.setComponentSign = exports.toReport = exports.recordUsage = exports.report = exports.getScrollTop = exports.getWindowScrollTop = exports.addParentClassName = exports.addClassName = exports.getStyle = exports.closest = exports.ie = exports.getVersion = exports.cloneArray = exports.looseIndexOf = exports.offDocKeyDown = exports.onDocKeyDown = exports.offDocClick = exports.onDocClick = exports.offResize = exports.onResize = exports.isEmptyValue = exports.isEmptyObject = exports.isFunction = exports.isFile = exports.isDate = exports.isObject = exports.isUndefined = exports.isNumber = exports.isString = exports.isArray = exports.type = exports.date = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileoverview 兼容旧的，后续会去掉，禁止再使用与维护这里的函数
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */


var _index = require('./js/browser/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('./js/function/index');

var _index4 = _interopRequireDefault(_index3);

var _index5 = require('./js/string/index');

var _index6 = _interopRequireDefault(_index5);

var _index7 = require('./js/url/index');

var _index8 = _interopRequireDefault(_index7);

var _index9 = require('./js/type/index');

var _index10 = _interopRequireDefault(_index9);

var _index11 = require('./js/array/index');

var _index12 = _interopRequireDefault(_index11);

var _index13 = require('./js/load/index');

var _index14 = _interopRequireDefault(_index13);

var _index15 = require('./js/dom/index');

var _index16 = _interopRequireDefault(_index15);

var _index17 = require('./js/report/index');

var _index18 = _interopRequireDefault(_index17);

var _index19 = require('./js/react/index');

var _index20 = _interopRequireDefault(_index19);

var _index21 = require('./js/date/index');

var _index22 = _interopRequireDefault(_index21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var date = exports.date = {
    splitDateDataByFormat: _index22.default.splitDate,
    joinDateDataToFormat: _index22.default.joinDate
};

// 类型判断相关
var type = exports.type = _index10.default.type;
var isArray = exports.isArray = _index10.default.isArray;
var isString = exports.isString = _index10.default.isString;
var isNumber = exports.isNumber = _index10.default.isNumber;
var isUndefined = exports.isUndefined = _index10.default.isUndefined;
var isObject = exports.isObject = _index10.default.isObject;
var isDate = exports.isDate = _index10.default.isDate;
var isFile = exports.isFile = _index10.default.isFile;
var isFunction = exports.isFunction = _index10.default.isFunction;
var isEmptyObject = exports.isEmptyObject = _index10.default.isEmptyObject;
var isEmptyValue = exports.isEmptyValue = _index10.default.isEmptyValue;

/**
 * @fileoverview document, window的一些事件处理，不推荐使用这里的内容，推荐使用document.addEventListener等，这里主要是为了保留兼容
 */
var windowSizeList = [];

// 保留document.onclick，在销毁实例的时候重新把原来的onresize返回
if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.onresize !== 'undefined' && isFunction(window.onresize)) {
    windowSizeList.push(window.onresize);
}

var onResize = exports.onResize = function onResize(self) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    // 保留下原始的resize方法
    var index = -1;

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.jQuery !== 'undefined') {
        jQuery(window).on('resize', callback);
        self._windowOnResize = null;
    } else {
        if (windowSizeList.length > 0) {
            self._windowOnResize = windowSizeList[0];
        }

        if (typeof callback !== 'undefined' && isFunction(callback)) {
            index = windowSizeList.length;
            windowSizeList.push(callback);
        }

        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
            window.onresize = function () {
                var len = windowSizeList.length;
                var i = 0;

                for (; i < len; i++) {
                    if (typeof windowSizeList[i] !== 'undefined' && isFunction(windowSizeList[i])) {
                        windowSizeList[i](event);
                    }
                }
            };
        }
    }

    return index;
};

var offResize = exports.offResize = function offResize(self) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    if (index > -1) {
        windowSizeList[index] = null;
    }

    if (typeof self._windowOnResize !== 'undefined' && isFunction(self._windowOnResize)) {
        window.onresize = self._windowOnResize;
    }
};

if (!window.docClickList) {
    window.docClickList = [];
}

if (!window.docKeyDownList) {
    window.docKeyDownList = [];
}

var docClickList = window.docClickList;
var docKeyDownList = window.docKeyDownList;

// 保留document.onclick，在销毁实例的时候重新把原来的onresize返回
if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.onclick !== 'undefined' && isFunction(document.onclick) && docClickList.length < 1) {
    docClickList.push(document.onclick);
}

var onDocClick = exports.onDocClick = function onDocClick(self) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    // 保留下原始的resize方法
    var index = -1;

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.jQuery !== 'undefined' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object') {
        jQuery(document).on('click', callback);
        self._docOnClick = false;
    } else {
        if (typeof callback !== 'undefined' && isFunction(callback)) {
            index = docClickList.length;
            docClickList.push(callback);
        }

        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object') {
            document.onclick = function (event) {
                var len = docClickList.length;
                var i = 0;

                for (; i < len; i++) {
                    if (typeof docClickList[i] !== 'undefined' && isFunction(docClickList[i])) {
                        docClickList[i](event);
                    }
                }
            };
        }
    }

    return index;
};

var offDocClick = exports.offDocClick = function offDocClick(self) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    if (index > -1) {
        docClickList[index] = null;
    }

    if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.jQuery === 'undefined') {
        document.onclick = function (event) {
            var len = docClickList.length;
            var i = 0;

            for (; i < len; i++) {
                if (typeof docClickList[i] !== 'undefined' && isFunction(docClickList[i])) {
                    docClickList[i](event);
                }
            }
        };
    }
};

var onDocKeyDown = exports.onDocKeyDown = function onDocKeyDown(self) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    // 保留下原始的resize方法
    var index = -1;

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.jQuery !== 'undefined' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object') {
        jQuery(document).on('keydown', callback);
        self._docOnKeyDown = false;
    } else {

        if (docKeyDownList.length > 0) {
            self._docOnKeyDown = docKeyDownList[0];
        }

        if (typeof callback !== 'undefined' && isFunction(callback)) {
            index = docKeyDownList.length;
            docKeyDownList.push(callback);
        }

        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object') {
            document.onkeydown = function (event) {
                var len = docKeyDownList.length;
                var i = 0;

                for (; i < len; i++) {
                    if (typeof docKeyDownList[i] !== 'undefined' && isFunction(docKeyDownList[i])) {
                        docKeyDownList[i](event);
                    }
                }
            };
        }
    }

    return index;
};

var offDocKeyDown = exports.offDocKeyDown = function offDocKeyDown(self) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    if (index > -1) {
        docKeyDownList[index] = null;
    }

    if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof self._docOnKeyDown !== 'undefined' && isFunction(self._docOnKeyDown)) {
        document.onkeydown = self._docOnKeyDown;
    }
};

// 数组相关
var looseIndexOf = exports.looseIndexOf = _index12.default.indexOf;
var cloneArray = exports.cloneArray = _index12.default.cloneArray;

// 浏览器相关
var getVersion = exports.getVersion = _index2.default.getBrowserVersion;
var ie = exports.ie = {
    getVersion: getVersion
};

// dom相关
var closest = exports.closest = _index16.default.closest;
var getStyle = exports.getStyle = _index16.default.getStyle;
var addClassName = exports.addClassName = _index16.default.addClassName;
var addParentClassName = exports.addParentClassName = function addParentClassName() {
    var dom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (dom && dom.parentNode) {
        _index16.default.addClassName(dom.parentNode, className);
    }
};
var getWindowScrollTop = exports.getWindowScrollTop = function getWindowScrollTop() {
    return _index16.default.getScrollTop('body');
};
var getScrollTop = exports.getScrollTop = _index16.default.getScrollTop;

// 上报模块
var report = exports.report = _index18.default.report;
var recordUsage = exports.recordUsage = _index18.default.recordUsage;
var toReport = exports.toReport = _index18.default.toReport;
var setComponentSign = exports.setComponentSign = function setComponentSign() {
    var componentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var reportConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _index20.default.setComponentMark(componentClass, reportConfig, function () {
        _index18.default.reportComponentUsage({
            scope: reportConfig.scope || 'spaui',
            name: reportConfig.componentName,
            version: reportConfig.componentVersion
        });
    });
};

// 加载js
var loadJs = exports.loadJs = _index14.default.loadJs;

// url
var autoFillUrl = exports.autoFillUrl = _index8.default.autoFillUrl;

// string
var trim = exports.trim = _index6.default.trim;

// function
var noop = exports.noop = _index4.default.noop;

/*
 * 获取尺寸对应的className(不再维护)
 * @private
 * @return {string} 尺寸对应的classname
*/
var getSizeClassName = exports.getSizeClassName = function getSizeClassName() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _config$small = config.small,
        small = _config$small === undefined ? '' : _config$small,
        _config$large = config.large,
        large = _config$large === undefined ? 'size-lg' : _config$large,
        _config$extralarge = config.extralarge,
        extralarge = _config$extralarge === undefined ? 'size-xlg' : _config$extralarge;

    var result = '';

    switch (size) {
        case 'small':
            result = small;
            break;
        case 'large':
            result = large;
            break;
        case 'extralarge':
            result = extralarge;
            break;
    }

    return result;
};

var dom = exports.dom = _extends({}, _index16.default, {
    addParentClassName: addParentClassName,
    getWindowScrollTop: getWindowScrollTop
});

exports.default = {
    looseIndexOf: looseIndexOf,
    ie: ie,
    getVersion: getVersion,
    type: type,
    isArray: isArray,
    isString: isString,
    isNumber: isNumber,
    isUndefined: isUndefined,
    isObject: isObject,
    isDate: isDate,
    isFile: isFile,
    isFunction: isFunction,
    trim: trim,
    report: report,
    recordUsage: recordUsage,
    addParentClassName: addParentClassName,
    getStyle: getStyle,
    getSizeClassName: getSizeClassName,
    loadJs: loadJs,
    onResize: onResize,
    offResize: offResize,
    onDocClick: onDocClick,
    offDocClick: offDocClick,
    onDocKeyDown: onDocKeyDown,
    offDocKeyDown: offDocKeyDown,
    setComponentSign: setComponentSign,
    getWindowScrollTop: getWindowScrollTop,
    getScrollTop: getScrollTop,
    noop: noop,
    autoFillUrl: autoFillUrl,
    isEmptyValue: isEmptyValue,
    cloneArray: cloneArray,
    toReport: toReport,
    date: date,
    dom: dom
};